<template>
    <button class="button slightly-rounded m-2" @click="downloadSoundEvent">
        <span>Download Audio</span>
        <span class="icon"><i class="fas fa-download"></i></span>
    </button>
</template>

<script>
import { getSoundUrlRead } from '@/js/apis.js'
export default {
    name: 'DownloadAudioButton',
    props: ['requesting_user', 'object_key'],
    methods: {
        downloadSoundEvent(){
            console.log("downloadSoundEvent")
            getSoundUrlRead(this.requesting_user, this.object_key)
                .then((res, err) => {
                    window.open(res.url);
                })
        }
    }
}
</script>

